<div class="dialog-content-wrapper" fusePerfectScrollbar>
  <div mat-dialog-title>
    <span i18n class="title dialog-title">Cоответствие материалам из модели</span>
    <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="p-0 pb-0 m-0" fusePerfectScrollbar>
    <ng-container>
      <div i18n class="mat-body-2 yellow-50-bg m-0 py-4 px-6">Материалы</div>

      <mat-divider></mat-divider>

      <mat-table #tableMaterial [dataSource]="dataSourceMaterials" class="glance-matching-table">
        <!-- Original material name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell i18n *matHeaderCellDef>Материал из модели</mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ formatOriginMaterial(item) }}
          </mat-cell>
        </ng-container>

        <!-- Original material thickness Column -->
        <ng-container matColumnDef="thickness">
          <mat-header-cell i18n *matHeaderCellDef>Толщина</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <p class="text-truncate">{{ item.materialThickness }}</p>
          </mat-cell>
        </ng-container>

        <!-- Linked material name Column -->
        <ng-container matColumnDef="link_name">
          <mat-header-cell i18n *matHeaderCellDef>Материал для производства</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <span *ngIf="item.linkedMaterialName">{{ item.linkedMaterialName }}</span>
            <span *ngIf="!item.linkedMaterialName" i18n>Не назначен</span>
          </mat-cell>
        </ng-container>

        <!-- Size Column -->
        <ng-container matColumnDef="size">
          <mat-header-cell i18n *matHeaderCellDef>Формат</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <p class="text-truncate">{{ item.height }}&times;{{ item.width }}</p>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="materialDisplayedColumns"></mat-header-row>
        <mat-row *matRowDef="let item; columns: materialDisplayedColumns"> </mat-row>
      </mat-table>

      <ng-container *ngIf="dataSourceButts.data.length > 0">
        <div i18n class="mat-body-2 yellow-50-bg m-0 py-4 px-6">Облицовка</div>
        <mat-divider></mat-divider>
        <mat-table #tableButts [dataSource]="dataSourceButts" class="glance-matching-table">
          <!-- Original butt name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell i18n *matHeaderCellDef>Облицовка из модели</mat-header-cell>
            <mat-cell *matCellDef="let item">
              {{ formatOriginMaterial(item) }}
            </mat-cell>
          </ng-container>

          <!-- Original material thickness Column -->
          <ng-container matColumnDef="thickness">
            <mat-header-cell i18n *matHeaderCellDef>Толщина</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <p class="text-truncate">{{ item.materialThickness }}</p>
            </mat-cell>
          </ng-container>

          <!-- Linked butt name Column -->
          <ng-container matColumnDef="link_name">
            <mat-header-cell i18n *matHeaderCellDef>Облицовка для производства</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span *ngIf="item.linkedMaterialName">{{ item.linkedMaterialName }}</span>
              <span *ngIf="!item.linkedMaterialName" i18n>Не назначена</span>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="buttDisplayedColumns"></mat-header-row>
          <mat-row *matRowDef="let item; columns: buttDisplayedColumns"> </mat-row>
        </mat-table>
      </ng-container>

      <ng-container *ngIf="dataSourceSlots.data.length > 0">
        <div i18n class="mat-body-2 yellow-50-bg m-0 py-4 px-6">Пазы</div>
        <mat-divider></mat-divider>
        <mat-table #tableSlots [dataSource]="dataSourceSlots" class="glance-matching-table">
          <!-- Original slot name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell i18n *matHeaderCellDef>Паз из модели</mat-header-cell>
            <mat-cell *matCellDef="let item">
              {{ formatOriginMaterial(item) }}
            </mat-cell>
          </ng-container>

          <!-- Linked slot name Column -->
          <ng-container matColumnDef="link_name">
            <mat-header-cell i18n *matHeaderCellDef>Паз для производства</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span *ngIf="item.linkedMaterialName">{{ item.linkedMaterialName }}</span>
              <span *ngIf="!item.linkedMaterialName" i18n>Не назначен</span>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="slotDisplayedColumns"></mat-header-row>
          <mat-row *matRowDef="let item; columns: slotDisplayedColumns"> </mat-row>
        </mat-table>
      </ng-container>

      <ng-container *ngIf="dataSourceFasteners.data.length > 0">
        <div i18n class="mat-body-2 yellow-50-bg m-0 py-4 px-6">Фурнитура</div>
        <mat-divider></mat-divider>
        <mat-table [dataSource]="dataSourceFasteners" class="glance-matching-table">
          <!-- Original fastener name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell i18n *matHeaderCellDef>Фурнитура из модели</mat-header-cell>
            <mat-cell *matCellDef="let item">
              {{ formatOriginMaterial(item) }}
            </mat-cell>
          </ng-container>

          <!-- Linked fastener name Column -->
          <ng-container matColumnDef="link_name">
            <mat-header-cell i18n *matHeaderCellDef>Фурнитура для производства</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span *ngIf="item.linkedMaterialName">{{ item.linkedMaterialName }}</span>
              <span *ngIf="!item.linkedMaterialName" i18n>Не назначена</span>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="fastenerDisplayedColumns"></mat-header-row>
          <mat-row *matRowDef="let item; columns: fastenerDisplayedColumns"> </mat-row>
        </mat-table>
      </ng-container>

      <ng-container *ngIf="dataSourceAssembly.data.length">
        <div i18n class="mat-body-2 yellow-50-bg m-0 py-4 px-6">Покупные изделия</div>
        <mat-divider></mat-divider>
        <mat-table [dataSource]="dataSourceAssembly" class="glance-matching-table">
          <ng-container matColumnDef="name">
            <mat-header-cell i18n *matHeaderCellDef>Покупные изделия из модели</mat-header-cell>
            <mat-cell *matCellDef="let item">
              {{ formatOriginMaterial(item) }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="link_name">
            <mat-header-cell i18n *matHeaderCellDef>Покупные изделия для производства</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span *ngIf="item.linkedMaterialName">{{ item.linkedMaterialName }}</span>
              <span *ngIf="!item.linkedMaterialName" i18n>Не назначено</span>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="assemblyDisplayedColumns"></mat-header-row>
          <mat-row *matRowDef="let item; columns: assemblyDisplayedColumns"> </mat-row>
        </mat-table>
      </ng-container>
    </ng-container>
  </div>

  <div mat-dialog-actions class="m-0 p-4 flex flex-row justify-end items-center">
    <button i18n mat-raised-button class="mat-accent mr-4" (click)="dialogRef.close(undefined)">ОК</button>
    <button i18n mat-button (click)="dialogRef.close(undefined)">ОТМЕНА</button>
  </div>
</div>
